import { useState } from 'react';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { getIsSaving, getLastSavedPpsiId } from '../selectors';
import { createPpsi } from '../actions';
import { FranchiseType } from '../../../constants/franchiseType';
import { getConfigs } from '../../app/selectors';

const useCreatePpsi = () => {
  const [hasSaved, setHasSaved] = useState(false);
  const dispatch = useDispatch();
  const isSaving = useSelector(getIsSaving);
  const createdPpsiId = useSelector(getLastSavedPpsiId);
  const franchiseType = useSelector(getConfigs).toJS().franchise;

  const onCreatePpsi = (data, callback) => {
    const { formulaCode, modifyDate: hash } = data.dish;

    const ppsi = _.omit(data, ['dish', 'utensils', 'ingredientEntryIds']);

    const productAreaData = {
      piaProductArea: data.dish.piaProductArea,
      piaProductAreaName: data.dish.piaProductAreaName,
      piaRangeArea: data.dish.piaRangeArea,
      piaRangeAreaName: data.dish.piaRangeAreaName
    };

    dispatch(
      createPpsi(
        formulaCode,
        ppsi,
        callback,
        franchiseType !== FranchiseType.INGKA ? { ...productAreaData } : null
      )
    );
    setHasSaved(true);
  };

  return [onCreatePpsi, isSaving, hasSaved ? createdPpsiId : null];
};

export default useCreatePpsi;
